import React, { useEffect, useMemo, useState } from "react";
import { getContractTypes } from "common/services/contracts.service";
import { normalize } from "common/lib/normalize";
import { FilterValueSelect } from "Components/Common/TableFilters";

type ContractTypeFilterProps = {
  onChange: (value: any) => void;
  value: any;
  isLTA?: boolean;
};

const ContractTypeFilter = ({
  onChange,
  value,
  isLTA,
}: ContractTypeFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getContractTypes({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
        });

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FilterValueSelect
      id="contractTypeFilter"
      placeholder={isLTA ? "Select LTA Services" : "Select Contract Type"}
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
    />
  );
};

export default ContractTypeFilter;
